/* History line (.hist) and the History drawer (G1). */
.line {
  color: var(--text-muted);
  font-size: 12px;
  line-height: 1.6;
}

/* The History button keeps its 44 px box (QA-043); see `.inlineLink`. */
.line button {
  color: var(--text-link);
  font-size: 12px;
}

.overlay {
  position: fixed;
  inset: 0;
  z-index: 70;
  display: flex;
  justify-content: flex-end;
  background: var(--scrim);
}

.overlay[data-entering] {
  animation: fade var(--dur-base) ease-out;
}

.drawer {
  display: flex;
  flex-direction: column;
  width: min(440px, 100vw);
  height: 100%;
  background: var(--white);
  box-shadow: var(--shadow-drawer);
  outline: none;
}

.drawer[data-entering] {
  animation: slide var(--dur-base) var(--ease-out);
}

@keyframes fade {
  from {
    opacity: 0;
  }
}

@keyframes slide {
  from {
    transform: translateX(32px);
    opacity: 0;
  }
}

.dialog {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
  outline: none;
}

.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px;
  background: var(--brand-navy);
  color: var(--white);
}

.headText {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.eyebrow {
  color: var(--text-on-dark-muted);
}

.title {
  font-size: 22px;
  line-height: 1.15;
}

.close {
  display: grid;
  flex: none;
  place-items: center;
  width: 44px;
  height: 44px;
  border: 1px solid var(--white-a30);
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--white);
  cursor: pointer;
}

.close[data-hovered] {
  background: var(--white-a12);
}

.body {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 18px;
  min-height: 0;
  padding: 20px;
  overflow-y: auto;
}

.current {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.currentLabel {
  color: var(--text-muted);
  font-size: 12px;
}

.currentValue {
  color: var(--text-heading);
  font-size: 32px;
  line-height: 1.1;
}

.sectionLabel {
  margin: 0;
  color: var(--text-muted);
}

.list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.entry {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px;
  border: 1px solid var(--border-card);
  border-radius: var(--radius-sm);
  font-size: 13px;
}

.latest {
  border-left: 3px solid var(--brand-gold);
}

.change {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  color: var(--text-heading);
  font-size: 14px;
  font-weight: var(--fw-bold);
}

.field {
  color: var(--text-secondary);
  font-weight: var(--fw-semibold);
}

.who {
  color: var(--text-body);
}

.meta {
  color: var(--text-muted);
}

.reason {
  color: var(--text-secondary);
}

.source {
  align-self: flex-start;
}

/* A way on from the timeline ("Open in the audit log"). */
.footer {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding-top: 4px;
}
